import { render } from "./CreateNewGroupForm.vue?vue&type=template&id=2f74f52e"
import script from "./CreateNewGroupForm.vue?vue&type=script&lang=js"
export * from "./CreateNewGroupForm.vue?vue&type=script&lang=js"
script.render = render

export default script